import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { FormFooterWrapper } from './styled/FormFooter';

var FormFooter = function (_Component) {
  _inherits(FormFooter, _Component);

  function FormFooter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FormFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormFooter.__proto__ || _Object$getPrototypeOf(FormFooter)).call.apply(_ref, [this].concat(args))), _this), _this.renderChildren = function () {
      return React.Children.map(_this.props.children, function (child) {
        return React.cloneElement(child, {
          form: _this.props.form
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /** For we just render all children. TODO: implement actions provider which can generate
   * Primary / Secondary buttons and actionsContent if custom content is needed
   */


  _createClass(FormFooter, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        FormFooterWrapper,
        null,
        this.props.children
      );
    }
  }]);

  return FormFooter;
}(Component);

FormFooter.defaultProps = {};
export default FormFooter;